@if (form) {
  <form [formGroup]="form">
    <div class="row mt-4">
      <div class="col-6 col-md-4 col-lg-3">
        <app-material-input-datepicker formControlName="date_from"
          [placeholder]="'Дата начала'"
          [require]="true">
          Начало действия
        </app-material-input-datepicker>
      </div>
      <div class="col-6 col-md-4 col-lg-3">
        <app-material-input-datepicker formControlName="date_to"
          [placeholder]="'Дата окончания'"
          [require]="true">
          Окончание действия
        </app-material-input-datepicker>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-xl-10 col-xl-8">
        <app-material-textarea [rows]="20" formControlName="condition_text" [placeholder]="'Условия реализации'"
          [require]="true">
          Условия реализации
        </app-material-textarea>
      </div>
    </div>
    <!--  <div class="row">-->
    <!--    <div class="col-12 col-xl-10 col-xl-8">-->
    <!--      <div class="caption mb-2 mt-3">Квартиры</div>-->
    <!--      <div class="row">-->
    <!--        <div class="col-12 col-sm-6 col-lg-12 col-xl-6">-->
    <!--          <app-material-input formControlName="flat_agent_remuneration"-->
    <!--                              [placeholder]="txt_spn">-->
    <!--            {{ txt_spn }}-->
  <!--          </app-material-input>-->
<!--        </div>-->
<!--        <div class="col-12 col-sm-6 col-lg-12 col-xl-6">-->
<!--          <app-material-input formControlName="flat_agent_remuneration_share"-->
<!--                              [placeholder]="txt_sa">-->
<!--            {{ txt_sa }} (Доля <span class="bold">-->
<!--              {{ form.get('flat_agent_remuneration')?.value | partRate : form.get('flat_agent_remuneration_share')?.value: 'front' }}-->
<!--              </span>)-->
<!--          </app-material-input>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="caption mb-2 mt-3">Коммерция</div>-->
<!--      <div class="row">-->
<!--        <div class="col-12 col-sm-6 col-lg-12 col-xl-6">-->
<!--          <app-material-input formControlName="commercial_agent_remuneration"-->
<!--                              [placeholder]="txt_spn">-->
<!--            {{ txt_spn }}-->
<!--          </app-material-input>-->
<!--        </div>-->
<!--        <div class="col-12 col-sm-6 col-lg-12 col-xl-6">-->
<!--          <app-material-input formControlName="commercial_agent_remuneration_share"-->
<!--                              [placeholder]="txt_sa">-->
<!--            {{ txt_sa }} (Доля <span class="bold">-->
<!--                  {{ form.get('commercial_agent_remuneration')?.value | partRate : form.get('commercial_agent_remuneration_share')?.value : 'front' }}-->
<!--                  </span>)-->
<!--          </app-material-input>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div *ngIf="complexes && settings" formArrayName="complexes">-->
<!--        <div class="caption mb-2 mt-4">Использовать общие настройки КВ:</div>-->
<!--        <div class="row">-->
<!--          <div class="col-12 mb-2 mt-2 text-sm" *ngIf="!complexes">В данный момент комплексов нет</div>-->
<!--          <div class="col-sm-6" *ngFor="let complex of complexes.controls; let id = index" [formGroupName]="id">-->
<!--            <app-material-input-checkbox formControlName="is_checked" [require]="true">-->
<!--              {{ complex.value.caption }}-->
<!--            </app-material-input-checkbox>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="mb-5">-->
<!--    <div *ngIf="complexes && settings" formArrayName="settings" class="end_block_padding">-->
<!--      <div class="row">-->
<!--        <ng-container *ngFor="let setting of settings.controls; let id = index">-->
<!--          <div-->
<!--            class="col-12 col-xl-6"-->
<!--            *ngIf="complexes.at(id) && !complexes.at(id).get('is_checked').value"-->
<!--            [formGroupName]="id">-->
<!--            <div-->
<!--              class="panel p-3 bg-white mb-3 pt-3 pb-3 mr-0 ml-0">-->
<!--              <div class="caption-sm mb-2 mt-0">{{ complexes.at(id).value.caption }}</div>-->
<!--              <div class="caption-sm mb-2 mt-3">Квартиры</div>-->
<!--              <div class="row">-->
<!--                <div class="col-sm-6">-->
<!--                  <app-material-input formControlName="flat_agent_remuneration"-->
<!--                                      [placeholder]="txt_spn">-->
<!--                    {{ txt_spn }}-->
<!--                  </app-material-input>-->
<!--                </div>-->
<!--                <div class="col-sm-6">-->
<!--                  <app-material-input formControlName="flat_agent_remuneration_share"-->
<!--                                      [placeholder]="txt_sa">-->
<!--                    {{ txt_sa }} (Доля <span class="bold">-->
<!--                        {{ setting.get('flat_agent_remuneration').value | partRate : setting.get('flat_agent_remuneration_share').value : 'front' }}-->
<!--                        </span>)-->
<!--                  </app-material-input>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="caption-sm mb-2 mt-3">Коммерция</div>-->
<!--              <div class="row">-->
<!--                <div class="col-sm-6">-->
<!--                  <app-material-input formControlName="commercial_agent_remuneration"-->
<!--                                      [placeholder]="txt_spn">-->
<!--                    {{ txt_spn }}-->
<!--                  </app-material-input>-->
<!--                </div>-->
<!--                <div class="col-sm-6">-->
<!--                  <app-material-input formControlName="commercial_agent_remuneration_share"-->
<!--                                      [placeholder]="txt_sa">-->
<!--                    {{ txt_sa }} (Доля <span class="bold">-->
<!--                        {{ setting.get('commercial_agent_remuneration')?.value | partRate : setting.get('commercial_agent_remuneration_share')?.value : 'front' }}-->
<!--                        </span>)-->
<!--                  </app-material-input>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </ng-container>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</form>
}
<div class="row no-gutters gutters-4 align-items-center mt-4 mb-4">
  <div class="col-6">
    <button (click)="onSubmit()" type="button" [disabled]=""
      class="button fixed_buttons_block_main" [ngClass]="{'button_disabled': false}">
      Сохранить
    </button>
  </div>
</div>
